import { defineMessages } from 'react-intl';

export default defineMessages({
    qualifications: {
        id: 'ml.quoteandbind.common.qualification.Qualifications',
        defaultMessage: 'Qualifications'
    },
    saveSubmissionErrorTitle: {
        id: 'ml.quoteandbind.ho.qualification.Unable to save submission',
        defaultMessage: 'Unable to save submission'
    },
    saveSubmissionErrorMessage: {
        id: 'ml.quoteandbind.ho.qualification.Error save quote submission',
        defaultMessage: 'An error occurred while attempting to save quote submission.'
    },
    policyTypeChangedWarning: {
        id: 'ml.quoteandbind.ho.qualification.policyTypeChangedWarning',
        defaultMessage: '{firstLine}{lineBreak}{secondLine}'
    },
    policyTypeChangedWarningFirstLine: {
        id: 'ml.quoteandbind.ho.qualification.policyTypeChangedWarningFirstLine',
        defaultMessage: 'Based on the information entered, the policy type has been changed'
    },
    policyTypeChangedWarningSecondLine: {
        id: 'ml.quoteandbind.ho.qualification.policyTypeChangedWarningSecondLine',
        defaultMessage: 'Please review before proceeding'
    },
    confirmEmployerAndAffiliations: {
        id: 'ml.quoteandbind.ho.qualification.Confirm your employer and affiliations next',
        defaultMessage: 'We\'ll confirm your {boldText} next'
    },
    workOnEmployerAndAffiliations: {
        id: 'ml.quoteandbind.ho.qualification.Work on your employer and affiliations next',
        defaultMessage: 'We\'ll work on your {employerAndAffiliations} next'
    },
    employerAndAffiliations: {
        id: 'ml.quoteandbind.ho.Employer and affiliations',
        defaultMessage: 'employer and affiliations'
    },
    OriginalEffectiveDate: {
        id: 'ml.quoteandbind.common.qualification.OrioginalEffectiveDate',
        defaultMessage: 'Please enter a valid date in a MM/YYYY format for the Original Effective Date of your prior policy.'
    },
    FutureEffectiveDate: {
        id: 'ml.quoteandbind.common.qualification.FutureEffectiveDate',
        defaultMessage: 'Original Effective Date of your prior policy cannot be greater than current date.'
    },
    baseWizardMessageNonRenters: {
        id: 'ml.quoteandbind.qualification.wizardMessagePa',
        defaultMessage: 'We’ll find your {boldText} next'
    },
    driversAndVehicles: {
        id: 'ml.quoteandbind.qualification.driversAndVehicles',
        defaultMessage: 'drivers and vehicles'
    },
    propertyDetails: {
        id: 'ml.quoteandbind.qualification.propertyDetails',
        defaultMessage: 'property details'
    },
    policyInfo: {
        id: 'ml.quoteandbind.qualification.policyInfo',
        defaultMessage: 'policy info'
    },
    discounts: {
        id: 'ml.quoteandbind.qualification.discounts',
        defaultMessage: 'discounts'
    },
    somethingWentWrong: {
        id: 'ml.quoteandbind.qualification.somethingWentWrong',
        defaultMessage: 'Something went wrong during this process. Please try again.'
    },
    NoCarrierError: {
        id: 'ml.quoteandbind.qualification.NoCarrier',
        defaultMessage: 'Please select current carrier.'
    },
    CompanyPolicyNumber: {
        id: 'ml.quoteandbind.qualification.CompanyPolicyNumber',
        defaultMessage: 'Company Policy Number should be less than 25 characters long and be strictly alphanumeric.'
    },
    homeCondoTenant: {
        id: 'ml.quoteandbind.qualification.We need to talk',
        defaultMessage: 'We need to talk to you to complete your quote. '
    },
    homeCondoTenantContent: {
        id: 'ml.quoteandbind.qualification.To finalize your quote',
        defaultMessage: 'To finalize your quote, please give us a call at {phoneNum} and provide your quote number {quoteID}.One of our licensed specialists will be happy to assist you in completing the process.'
    },
    invalidLandlordOfferingErrorTitle: {
        id: 'ml.quoteandbind.ho.qualification.Invalid Occupancy Selection',
        defaultMessage: 'Invalid Occupancy Selection'
    },
    invalidLandlordOffering: {
        id: 'ml.quoteandbind.qualification.Landlord Condo policies are supported only with Value Plus offering',
        defaultMessage: 'Landlord Condo policies are only available under the Value Plus offering. To proceed, please either change the occupancy to “Myself” or rewrite to a new Landlord policy with the Value Plus offering.'
    },
    animalLiabilityExclusion: {
        id: 'ml.quoteandbind.qualification.animalLiabilityExclusion',
        defaultMessage: 'We will require an Animal Liability Exclusion to be included on your policy'
    },
    vacantDwellingUWWarning: {
        id: 'ml.quoteandbind.qualification.vacantDwellingUWWarning',
        defaultMessage: 'Vacant dwellings are ineligible for coverage under this product. However, coverage may be available under our Landlord product.'
    },
    vacantDwellingUWWarningLandlordCondo: {
        id: 'ml.quoteandbind.qualification.vacantDwellingUWWarningLandlordCondo',
        defaultMessage: 'Platinum Package is not available when Occupancy is Vacant. Offering has been updated to Landlord Condo (Comprehensive).'
    }, 
    vacantDwellingUWWarningLandlordHome: {
        id: 'ml.quoteandbind.qualification.vacantDwellingUWWarningLandlordHome',
        defaultMessage: 'Platinum Package is not available when Occupancy is Vacant. Offering has been updated to Dwelling Fire Three (Comprehensive).'
    },
    tenantOccupied: {
        id: 'ml.quoteandbind.qualification.tenantOccupied',
        defaultMessage: 'Tenant occupied'
    },
    dayCareNotification: {
        id: 'ml.quoteandbind.qualification.dayCareNotification',
        defaultMessage: 'We will require the submission to have childcare coverage'
    },
});
